import React from 'react'
import {ActionSheet, ActionSheetButton} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import Loader from 'react-loader-spinner';
import firebase from 'firebase/app';
import 'firebase/functions';

import {showToastMessage} from "../../../modules/toast";
import {showAlertMessage} from "../../../modules/alert";
import {useNaverPlaceApiData} from "../../../modules/native";

class NaverPlaceReviewsActionSheet extends React.Component {
    state = {
        targetNaverPlaceReviewsActionSheet: {
            targetMarker: null,
            open: false,
            isLoading: false,
            showMore: false,
            currentStart: 1,
            data: null,
            list: []
        },
        iframeActionSheet: {open: false, frameUrl: null},
    };

    componentDidMount() {
        this.setState({targetMarker: this.props.targetMarker, open: true});
        this.showNaverPlaceReviews(this.props.targetMarker, 1);
    }

    componentWillReceiveProps(nextProps){
        if(this.props.usedNaverPlaceApiData === true && nextProps.usedNaverPlaceApiData === false){
            switch (nextProps.naverPlaceApiTarget) {
                case 'PLACE_REVIEWS':
                    const previousList = this.state.targetNaverPlaceReviewsActionSheet.list;
                    const list = previousList.concat(nextProps.naverPlaceApiData.items);
                    let currentStart = this.state.targetNaverPlaceReviewsActionSheet.currentStart;
                    let showMore = false;

                    if(nextProps.naverPlaceApiData.total > currentStart + 11){
                        showMore = true;
                        currentStart = currentStart + 11;
                    }
                    this.setState({targetNaverPlaceReviewsActionSheet: {...this.state.targetNaverPlaceReviewsActionSheet, data: nextProps.naverPlaceApiData, list: list, showMore: showMore, currentStart: currentStart, isLoading: false}});
                    break;
                default:
                    console.error('NO TARGET');
            }
            this.props.useNaverPlaceApiData();
        }
    }

    showNaverPlaceReviews = (marker, start) => {
        let currentStart = 1;

        if(start === 1){
            this.setState({targetNaverPlaceReviewsActionSheet: {targetMarker: marker, open: true, isLoading: true, showMore: false, currentStart: currentStart, data: null, list: []}});
        }else{
            currentStart = start;
            this.setState({targetNaverPlaceReviewsActionSheet: {...this.state.targetNaverPlaceReviewsActionSheet, open: true, isLoading: true, showMore: false, currentStart: currentStart, data: null}});
        }

        const url = 'https://m.store.naver.com/sogum/api/fsasReviews?exclude=&businessId=' + marker.id + '&rcfr=0&start=' + currentStart + '&display=11';

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_NAVER_PLACE_API', 'url': url, target: 'PLACE_REVIEWS'});
            window.postMessage(message, "*");
        }else if(window.isETView === true || window.isETView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_NAVER_PLACE_API', 'url': url, target: 'PLACE_REVIEWS'});
            window.sendMessageToElectron(message, "*");
        }else{
            const searchNaverPlace = firebase.functions().httpsCallable('searchNaverPlace');
            searchNaverPlace({url: url}).then((result) => {
                if(result.data.result === 'success'){
                    const data = JSON.parse(result.data.data);
                    const previousList = this.state.targetNaverPlaceReviewsActionSheet.list;
                    const list = previousList.concat(data.items);
                    let showMore = false;

                    if(data.total > currentStart + 11){
                        showMore = true;
                        currentStart = currentStart + 11;
                    }
                    this.setState({targetNaverPlaceReviewsActionSheet: {...this.state.targetNaverPlaceReviewsActionSheet, data: data, list: list,showMore: showMore, currentStart: currentStart, isLoading: false}});

                }else{
                    this.props.showAlertMessage("정보를 가져오는데 오류가 발생하였습니다. 잠시후에 시도해주시기 바랍니다.", "검색 오류");
                    this.setState({targetNaverPlaceReviewsActionSheet: {...this.state.targetNaverPlaceReviewsActionSheet, isLoading: false}});
                }
            });
        }
    };

    render() {
        const TNPRAS = this.state.targetNaverPlaceReviewsActionSheet;

        return (
            <div>

                {
                    TNPRAS.open ?
                        <ActionSheet className="target-naver-place-reviews-action-sheet" isOpen={TNPRAS.open} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true} title={TNPRAS.targetMarker.name  + ' 리뷰'}>
                            <ul className="list list--material naver-place-reviews-list">
                                {
                                    !TNPRAS.isLoading && TNPRAS.list.length === 0 ?
                                        <li className="list-item list-item--material">
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title text-center">
                                                    작성된 리뷰가 없습니다.
                                                </div>
                                            </div>
                                        </li>
                                        :
                                        null
                                }

                                {
                                    TNPRAS.list.map((e, i) => {
                                        return (
                                            <li key={['place', 'review', e.id, i].join('_')} className="list-item list-item--material" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: e.url}})}>
                                                <div className="list-item__left list-item--material__left">
                                                    <img className="list-item__thumbnail" src={e.thumbnailUrl && e.thumbnailUrl !== '' ? ['https://search.pstatic.net/common/?autoRotate=true&quality=95&src=', e.thumbnailUrl, '&type=f174_174'].join('') : 'https://fakeimg.pl/150x150/?text=No Image'} onError={(e)=>{e.target.src = "https://fakeimg.pl/150x150/?text=No Image"}} alt={e.title}/>
                                                </div>
                                                <div className="list-item__center list-item--material__center">
                                                    <div className="list-item__title list-item--material__title">{e.title.replace(/<\/?[^>]+(>|$)/g, "")} {e.typeName ? <small>{e.typeName}</small>: null} <small>{e.date ? e.date: null}</small></div>
                                                    <div className="list-item__subtitle list-item--material__subtitle">{e.contents ? e.contents.replace(/<\/?[^>]+(>|$)/g, "") : null}</div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }

                                {
                                    TNPRAS.isLoading ?
                                        <li className="list-item list-item--material">
                                            <div className="list-item__center list-item--material__center">
                                                <div className="list-item__title list-item--material__title text-center">
                                                    <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                                </div>
                                            </div>
                                        </li>
                                        :
                                        TNPRAS.showMore ?
                                            <li className="list-item list-item--material">
                                                <div className="list-item__center list-item--material__center">
                                                    <div className="list-item__title list-item--material__title text-center" onClick={() => this.showNaverPlaceReviews(TNPRAS.targetMarker, TNPRAS.currentStart)}>
                                                        <i className="fa fa-plus"/> 더보기
                                                    </div>
                                                </div>
                                            </li>
                                            :
                                            null
                                }
                            </ul>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>리뷰 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

                {
                    this.state.iframeActionSheet.open ?
                        <ActionSheet className="iframe-action-sheet" isOpen={this.state.iframeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} isCancelable={true} title={'이하 정보는 네이버 사이트입니다.'}>
                            <iframe id="iframe-action-sheet" title="iframe-action-sheet" src={this.state.iframeActionSheet.frameUrl}></iframe>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

            </div>
        )
    }
}

const mapStateToProps = ({ user, native }) => ({
    userInfo: user.userInfo,
    usedNaverPlaceApiData: native.usedNaverPlaceApiData,
    naverPlaceApiTarget: native.naverPlaceApiTarget,
    naverPlaceApiData: native.naverPlaceApiData,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    useNaverPlaceApiData: () => dispatch(useNaverPlaceApiData()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(NaverPlaceReviewsActionSheet))

